import React from 'react';
import {
    FileTextOutlined,
    UserOutlined,
} from "@ant-design/icons";
import AudioPlayerCustom from "../audioPlayerCustom/AudioPlayerCustom";
import clockImg from "../../assets/image/icons-messages-tick-01.png";
import delevredIcon from "../../assets/image/icons-messages-tick-03.png";
import seenIcon from "../../assets/image/icons-messages-tick-04.png";
import singleCheck from "../../assets/image/icons-messages-tick-02.png";
import moment from 'moment';
import {
    Avatar,
} from "antd";
import { Downloader } from '../fileDownloader/Downloader';
import ImageAttachmentPreview from '../fileDownloader/ImageAttachmentPreview';
import { getAttachmentName, isImageAttachment } from '../../helpers/attachmentUtils';

const FileAttachmentCard = ({ file }) => {
    const image = isImageAttachment(file);
    const fileName = getAttachmentName(file, "");
    const shortName = fileName ? `${fileName.substring(0, 8)}...${fileName.substring(20)}` : "";

    return (
        <div className="download" style={image ? { display: "block" } : undefined}>
            {image ? (
                <ImageAttachmentPreview file={file} />
            ) : (
                <>
                    <div className="avatar-sm me-3 ms-0">
                        <div className="ava-icon">
                            <FileTextOutlined />
                        </div>
                    </div>
                    <div className="flex-grow-1">
                        <div className="text-start">
                            <h5 className="font-size-14 mb-1">{shortName}</h5>
                            <p className="text-muted font-size-13 mb-0"></p>
                        </div>
                    </div>
                </>
            )}
            <div className="avatar-sm me-3 ms-0">
                <div className="avatar-down">
                    <Downloader file={file} filename={fileName} />
                </div>
            </div>
        </div>
    );
};

const MessagesView = React.memo(({ i, userData, updatedName }) => {

    const renderMessage = (message) => {
        const urlPattern = /(https?:\/\/[^\s]+)/g;
        if (urlPattern.test(message)) {
            return message.split(urlPattern).map((part, i) => {
                if (urlPattern.test(part)) {
                    return (
                        <a href={part} key={i} target="_blank" rel="noopener noreferrer">
                            {part}
                        </a>
                    );
                }
                return part;
            });
        }
        return message
            .split("\n")
            .map((line, index) => <div key={index}>{line}</div>);
    };

    return (
        <div className="clientMsg">
            <>
                {i?.senderID == userData?._id ? (
                    <>
                        {i?.type === "joiner" ? (
                            <div
                                className="joins"
                                style={{
                                    width: "100%",
                                    fontStyle: "italic",
                                    textAlign: "center",
                                    lineHeight: "0px",
                                    marginBottom: "30px",
                                    fontSize: "12px",
                                }}
                            >
                                <p
                                    className="agentjointext"
                                    style={{ textAlign: "center" }}
                                >
                                    <span className="leaveTitle">{i?.message}</span>
                                </p>
                                <span
                                    style={{
                                        fontSize: 10,
                                        backgroundColor: "white",
                                        padding: "0px 12px",
                                        zIndex: "1",
                                        position: "relative",
                                        borderRadius: "19px",
                                    }}
                                >
                                    {moment(i?.time).fromNow(true)}
                                </span>
                            </div>
                        ) : i?.type === "leave" ? (
                            <div
                                className="leave"
                                style={{
                                    width: "100%",
                                    fontStyle: "italic",
                                    textAlign: "center",
                                    lineHeight: "0px",
                                    marginBottom: "30px",
                                    fontSize: "12px",
                                }}
                            >
                                <p
                                    className="agentjointext"
                                    style={{ textAlign: "center" }}
                                >
                                    <span className="leaveTitle">{i?.message}</span>
                                </p>
                                <span
                                    style={{
                                        fontSize: 10,
                                        backgroundColor: "white",
                                        padding: "0px 12px",
                                        zIndex: "1",
                                        position: "relative",
                                        borderRadius: "19px",
                                    }}
                                >
                                    {moment(i?.time).fromNow(true)}
                                </span>
                            </div>
                        ) : (
                            <div className="conversation-list right">
                                <div className="chat-avatar right">
                                    <Avatar icon={<UserOutlined />} />
                                </div>
                                <div className="user-chat-content">
                                    <div className="ctext-wrap">
                                        <div className="ctext-wrap-content right">
                                            {/* {i?.message} */}
                                            <p className="mb-0">
                                                {" "}
                                                {renderMessage(i?.message)}
                                            </p>
                                            {i?.file !== null && (
                                                <FileAttachmentCard file={i?.file} />
                                            )}
                                            {i?.audio && i?.audio !== null && (
                                                <AudioPlayerCustom audioUrl={i?.audio?.url || URL.createObjectURL(i?.audio?.audio)} />
                                            )}

                                            <p className="chat-time mb-0">
                                                {/* <i className="ri-time-line align-middle"></i> */}
                                                <span style={{ marginRight: 10 }}>
                                                    {i?.status == "wait" ? (
                                                        <img
                                                            src={clockImg}
                                                            style={{ width: 15, height: 13 }}
                                                            alt="React Logo"
                                                        />
                                                    ) : i?.status == "sent" ? (
                                                        <img
                                                            src={singleCheck}
                                                            style={{ width: 15, height: 13 }}
                                                            alt="React Logo"
                                                        />
                                                    ) : i?.status == "delivered" ? (
                                                        <img
                                                            src={delevredIcon}
                                                            style={{ width: 15, height: 13 }}
                                                            alt="React Logo"
                                                        />
                                                    ) : (
                                                        <img
                                                            src={seenIcon}
                                                            style={{ width: 15, height: 13 }}
                                                            alt="React Logo"
                                                        />
                                                    )}
                                                </span>
                                                <span className="align-middle">
                                                    {i?.time !== undefined && i?.time !== null
                                                        ? moment(i?.time).fromNow()
                                                        : moment(
                                                            new Date().toISOString()
                                                        ).fromNow()}
                                                    {/* {moment(i?.time).fromNow()} */}
                                                </span>
                                            </p>
                                        </div>
                                    </div>
                                    <div className="conversation-name">
                                        {userData?.sudoName}
                                    </div>
                                </div>
                            </div>
                        )}
                    </>
                ) : (
                    <>
                        {i?.type === "joiner" ? (
                            <div
                                className="joins"
                                style={{
                                    width: "100%",
                                    fontStyle: "italic",
                                    textAlign: "center",
                                    lineHeight: "0px",
                                    marginBottom: "30px",
                                    fontSize: "12px",
                                }}
                            >
                                <p
                                    className="agentjointext"
                                    style={{ textAlign: "center" }}
                                >
                                    <span className="leaveTitle">{i?.message}</span>
                                </p>
                                <span
                                    style={{
                                        fontSize: 10,
                                        backgroundColor: "white",
                                        padding: "0px 12px",
                                        zIndex: "1",
                                        position: "relative",
                                        borderRadius: "19px",
                                    }}
                                >
                                    {moment(i?.time).fromNow(true)}
                                </span>
                            </div>
                        ) : i?.type === "disconnect" ? (
                            <div
                                className="disconnect"
                                style={{
                                    width: "100%",
                                    fontStyle: "italic",
                                    textAlign: "center",
                                    lineHeight: "0px",
                                    marginBottom: "30px",
                                    fontSize: "12px",
                                }}
                            >
                                <p
                                    className="agentjointext"
                                    style={{ textAlign: "center" }}
                                >
                                    <span className="leaveTitle">{i?.message}</span>
                                </p>
                                <span
                                    style={{
                                        fontSize: 10,
                                        backgroundColor: "white",
                                        padding: "0px 12px",
                                        zIndex: "1",
                                        position: "relative",
                                        borderRadius: "19px",
                                    }}
                                >
                                    {moment(i?.time).fromNow(true)}
                                </span>
                            </div>
                        ) : i?.type === "leave" ? (
                            <div
                                className="leave"
                                style={{
                                    width: "100%",
                                    fontStyle: "italic",
                                    textAlign: "center",
                                    lineHeight: "0px",
                                    marginBottom: "30px",
                                    fontSize: "12px",
                                }}
                            >
                                <p
                                    className="agentjointext"
                                    style={{ textAlign: "center" }}
                                >
                                    <span className="leaveTitle">
                                        {renderMessage(i?.message)}
                                    </span>
                                </p>
                                <span
                                    style={{
                                        fontSize: 10,
                                        backgroundColor: "white",
                                        padding: "0px 12px",
                                        zIndex: "1",
                                        position: "relative",
                                        borderRadius: "19px",
                                    }}
                                >
                                    {moment(i?.time).fromNow(true)}
                                </span>
                            </div>
                        ) : i?.type === "widget" ? (
                            <div
                                className="wid"
                                style={{
                                    width: "100%",
                                    fontStyle: "italic",
                                    textAlign: "center",
                                    lineHeight: "0px",
                                    marginBottom: "30px",
                                    fontSize: "12px",
                                }}
                            >
                                <p
                                    className="agentjointext"
                                    style={{ textAlign: "center", fontSize: 12 }}
                                >
                                    <span className="leaveTitle">
                                        {renderMessage(i?.message)}
                                    </span>
                                </p>
                                <span
                                    style={{
                                        fontSize: 10,
                                        backgroundColor: "white",
                                        padding: "0px 12px",
                                        zIndex: "1",
                                        position: "relative",
                                        borderRadius: "19px",
                                    }}
                                >
                                    {moment(i?.time).fromNow(true)}
                                </span>
                            </div>
                        ) : (
                            <>
                                <div className="conversation-list">
                                    <div className="chat-avatar">
                                        <Avatar icon={<UserOutlined />} />
                                    </div>
                                    <div className="user-chat-content">
                                        <div className="ctext-wrap">
                                            <div className="ctext-wrap-content">
                                                <p className="mb-0">
                                                    {renderMessage(i?.message)}
                                                </p>
                                                {i?.file !== null && (
                                                    <FileAttachmentCard file={i?.file} />
                                                )}
                                                {/* {i?.audio && i?.audio !== null && <audio style={{ height: 35, width: 250 }} src={i?.audio?.url} controls />} */}
                                                {i?.audio && i?.audio !== null && (
                                                    <AudioPlayerCustom
                                                        audioUrl={i?.audio?.url || URL.createObjectURL(i?.audio?.audio)}
                                                    />
                                                )}

                                                <p className="chat-time mb-0">
                                                    <i className="ri-time-line align-middle"></i>
                                                    <span className="align-middle">
                                                        {moment(i?.time).fromNow()}
                                                    </span>
                                                </p>
                                            </div>
                                        </div>
                                        <div className="conversation-name">
                                            #[{updatedName}]
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </>
                )}
            </>
        </div>
    )
});


export default MessagesView 